<template>
    <b-overlay
        variant="white"
        :show="showLoading"
        spinner-variant="primary"
        blur="0"
        opacity=".85"
        rounded="sm"
    >
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <b-card
                    no-body
                    border-variant="light"
                >
                    <div class="card-header">
                        <div class="col-md-6 pl-0">
                            <b-card-title>{{ $t('Page(SendRequest):Component(Label):page-label') }}: {{ productName }}</b-card-title>
                        </div>
                        <div class="col-md-6 pr-0">
                            <SendRequestActions
                                :show-send-button="showSendButton"
                                @sendRequest="sendRequest"
                                @back="getBack"
                            />
                        </div>
                    </div>
                    <RequestedProducts
                        :products="products"
                        @change="onRequestedProductChange"
                        @sendEmail="sendEmail"
                    />
                </b-card>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <RequestDetails
                    ref="requestDetails"
                    :initially-unselected-legislations="initiallyUnselectedLegislations"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <SendRequestEmailExample
                    :supplier-name="emailExampleSupplierName"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <SendRequestActions
                    :show-send-button="showSendButton"
                    @sendRequest="sendRequest"
                    @back="getBack"
                />
            </div>
        </div>
    </b-overlay>
</template>

<script>
import { BFormInput, BFormRadio, BTable, BCardTitle, BCard, BFormDatepicker, BOverlay, BFormGroup,
    BListGroup, BListGroupItem, BFormCheckbox, BFormTextarea } from 'bootstrap-vue'
import {ProductApi} from "@core/api";
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import SendRequestActions from "@/views/product/components/send-request/SendRequestActions";
import RequestedProducts from "@/views/request/RequestedProducts";
import RequestDetails from "@/views/request/RequestDetails";
import SendRequestEmailExample from "@/views/product/SendRequestEmailExampleV2";
import {getNameOrId, ProductNames, ProductType} from "@/libs/product";
import {
    getInitiallyUnselectedLegislationIds,
} from '@/views/product/components/send-request/legislation-request-selection'

export default {
    components: {
        SendRequestActions, SendRequestEmailExample, RequestedProducts, RequestDetails,
        BCard, BCardTitle, BListGroup, BListGroupItem,
        BFormCheckbox, BFormTextarea, BFormGroup, BFormInput, BFormRadio, BFormDatepicker, BOverlay, BTable,
    },
    props: {
        id: {
            type: String
        },
        product: {
            type: Object,
            default() {
                return {

                };
            }
        }
    },
    data() {
        return {
            validProduct: this.product,
            products: [],
            showLoading: true,

            sendRequestInProgress: false,
            showSendButton: false,

            initiallyUnselectedLegislations: [],
            researchFlow: true
        };
    },
    methods: {
        initiateResearch(products) {
            this.sendRequestInProgress = true;
            this.showLoading = true;

            const request = {
                products: products.map(p => p.id),
                requestToSupplierData: {
                    ...this.$refs.requestDetails.getData()
                }
            };
            if (this.$route.query.et) {
                request.requestToSupplierData.emailOptions = {
                    type: this.$route.query.et,
                    id: this.$route.query.eid
                };
            }
            ProductApi
                .initiateRequest(this.id, request)
                .then(r => {
                    this.$swal({
                        icon: 'success',
                        title: this.$t('Page(SendRequest):Component(RequestSentAck):title'),
                        text: this.$t('Page(SendRequest):Component(RequestSentAck):text'),
                        customClass: {
                            confirmButton: 'btn btn-primary',
                        },
                    });
                    setTimeout(() => {
                        this.$store.dispatch('refreshCounters');
                        this.$router.push({name: 'sent-requests'})
                    }, 1000);
                })
                .finally(() => {
                    this.showLoading = false
                    this.sendRequestInProgress = false;
                })
            ;
        },
        sendRequest() {
            if (this.sendRequestInProgress) {
                return;
            }

            const products = this.products.filter(p => p.selected);

            if (0 === products.length) {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'Select at least one product',
                        variant: 'danger'
                    },
                })
                return;
            }

            if (this.researchFlow) {
                this.initiateResearch(products);
                return;
            }

            this.sendRequestInProgress = true;
            this.showLoading = true;

            const request = {
                products: products.map(p => p.id),
                ...this.$refs.requestDetails.getData()
            };
            if (this.$route.query.et) {
                request.emailOptions = {
                    type: this.$route.query.et,
                    id: this.$route.query.eid
                };
            }
            ProductApi
                .sendRequest(this.id, request)
                .then(r => {
                    this.$swal({
                        icon: 'success',
                        title: this.$t('Page(SendRequest):Component(RequestSentAck):title'),
                        text: this.$t('Page(SendRequest):Component(RequestSentAck):text'),
                        customClass: {
                            confirmButton: 'btn btn-primary',
                        },
                    });
                    setTimeout(() => {
                        this.$store.dispatch('refreshCounters');
                        this.$router.push({name: 'sent-requests'})
                    }, 600);
                })
                .finally(() => {
                    this.showLoading = false
                    this.sendRequestInProgress = false;
                })
            ;
        },
        getBack() {
            this.$router.go(-1);
        },
        getContactName(supplier) {
            return supplier.contact.name;
        },
        getContactEmail(supplier) {
            return supplier.contact.communicationChannels[0].details;
        },
        onRequestedProductChange(product) {
            if (this.products.filter(p => p.selected).length > 0) {
                this.showSendButton = true;
            } else {
                this.showSendButton = false;
            }
        },
        sendEmail(product, doneCallback) {
            ProductApi.sendProductRequestEmail(parseInt(product.id)).then(() => {
                product.isEmailSent = true;
                doneCallback();
            });
        }
    },
    computed: {
        productName() {
            if (!this.validProduct.type) {
                return '';
            }

            return getNameOrId(this.validProduct.names, ProductNames.OUR_PRODUCT_NAME) || this.validProduct.names[0].value;
        },

        emailExampleSupplierName() {
            let suppliers = this.products.map(p => p.supplier);
            if (suppliers.length === 0) {
                return null;
            }
            if (suppliers.length === 1) {
                return suppliers[0].title;
            }
            for (let i = 1; i < suppliers.length; ++i) {
                if (suppliers[0].id !== suppliers[i].id) {
                    return null;
                }
            }

            return suppliers[0].title;
        }
    },
    created() {
        const requests = [];
        if (!this.product.type) {
            requests.push(ProductApi.getProduct(this.id).then(r => this.validProduct = r.data));
        }

        requests.push(ProductApi.getComponentsToRequest(this.id).then(r => {
            r.data.forEach(p => {
                p.selected = !p.ongoingRequestDate;

                if (p.selected) {
                    this.showSendButton = true;
                }
            });
            this.products = r.data;
        }));

        Promise.all(requests).then(() => {
            if (this.validProduct.type !== ProductType.GROUP && this.validProduct.legislations) {
                this.initiallyUnselectedLegislations = getInitiallyUnselectedLegislationIds(
                    this.validProduct.legislations,
                );
            }

            this.showLoading = false;
        })
    }
}
</script>
